import * as React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { connect } from 'react-redux';

import { NotificationTemplateInfo } from '../MultiSelect/common';
import AdhocNotificationButton from '../Notifications/AdhocNotification/AdhocNotificationButton';
import RBSelectList from '../RBSelectList/RBSelectList';
import {
  saveNotificationByTemplate,
  getTemplatesByOption,
  getNotificationReportInfo,
  getAllTemplates,
  getAllTokens,
} from '../NotificationTemplate/redux-objects/actions';
import * as urls from '../shared/urls';

import './assets/NotificationTemplateSelector.scss';
import {
  INotificationTemplate,
  INotificationFromTemplateSaveRequest,
  INotificationReportInfo,
  INotificationTokenType,
} from './business-objects/common';
import { toast } from 'react-toastify';

interface INotificationTemplateSelectorFormOwnProps {
  optionId?: number;
  showLabel?: boolean;
  reportId?: number;
}

interface INotificationTemplateSelectorPropsFromState {
  templatesByOption: INotificationTemplate[];
  tokenTypes: INotificationTokenType[];
  cachedAdhocNotification: any;
  webServiceURL: string;
  notificationReportInfo: INotificationReportInfo;
}

interface INotificationTemplateSelectorPropsFromActions {
  onSave: (event: any) => void;
  getTemplatesByOption: (optionId?: number) => void;
  saveNotificationByTemplate: (
    url: string,
    request: INotificationFromTemplateSaveRequest
  ) => Promise<void>;
  getNotificationReportInfo: (url: string, reportId: number) => Promise<void>;
  getAllTemplates: (url: string) => void;
  getAllTokens: (url: string) => void;
}

export interface INotificationTemplateSelectorProps
  extends INotificationTemplateSelectorFormOwnProps,
  INotificationTemplateSelectorPropsFromState,
  INotificationTemplateSelectorPropsFromActions { }

interface NotificationTemplateSelectorLocalState {
  selectedTemplate: INotificationTemplate;
  templatesForThisOption?: NotificationTemplateInfo[];
  showCustom: boolean;
  showModal: boolean;
  selectedVehicleId?: number;
  selectedOccupantId?: number;
  templateRequiresVehicleOrOccupant: boolean;
  templateRequiresOccupant: boolean;
  valid: boolean;
  allTokens: string[];
}

export class NotificationTemplateSelector extends React.Component<
  INotificationTemplateSelectorProps,
  NotificationTemplateSelectorLocalState
> {
  constructor(props) {
    super(props);
    this.state = {
      selectedTemplate: null,
      showCustom: false,
      showModal: false,
      templateRequiresVehicleOrOccupant: true,
      templateRequiresOccupant: true,
      valid: false,
      selectedVehicleId: null,
      selectedOccupantId: null,
      allTokens: [],
    };
  }

  componentDidMount() {
    const {
      optionId,
      templatesByOption,
      cachedAdhocNotification,
      webServiceURL,
    } = this.props;

    this.props.getAllTemplates(urls.GET_ALL_ACTIVE_NOTIFICATION_TEMPLATES);
    this.props.getAllTokens(urls.GET_ALL_TOKENS);
    this.props.getTemplatesByOption(optionId);

    if (this.props.reportId) {
      this.props
        .getNotificationReportInfo(
          urls.GET_NOTIFICATION_REPORT_INFO,
          this.props.reportId
        )
        .then(() => {
          //console.log('notification report info:',this.props.notificationReportInfo);
        });
    }
  }

  getTokensInString = (input: string): string[] => {
    var tokens = [];
    if (!input || input.length == 0) return tokens;
    input.replace(/\#(.*?)#/g, (a, b) => {
      tokens.push(b);
      return b;
    });

    //console.log(tokens);
    return tokens;
  };

  getAllTokensInTemplate = (template: INotificationTemplate): string[] => {
    if (template) {
      var tokens = [
        ...this.getTokensInString(template.body),
        ...this.getTokensInString(template.subject),
      ];
      console.log(tokens);
      return tokens;
    }
    return [];
  };

  selectedTemplateRequiresVehicle = () => {
    return this.props.tokenTypes
      .filter((x) => x.name == 'Vehicle')[0]
      .tokens.some((t) => this.state.allTokens.some((at) => at == t.name));
  };

  selectedTemplateRequiresOccupant = () => {
    return this.props.tokenTypes
      .filter((x) => x.name == 'Occupant / Driver')[0]
      .tokens.some((t) => this.state.allTokens.some((at) => at == t.name));
  };

  validateNotification = () => {
    // Removing validation for now because we aren't controlling which templates can be added to what queues
    // and at some point in these queues (like keywords) we may not have the data for the tags
    // So we can leave it to the notification validator to see that tags aren't populated sometimes

    return true;

    // if (
    //   (!this.selectedTemplateRequiresOccupant() ||
    //     (this.state.selectedOccupantId && this.state.selectedOccupantId > 0)) &&
    //   (!this.selectedTemplateRequiresVehicle() ||
    //     (this.state.selectedVehicleId && this.state.selectedVehicleId > 0))
    // ) {
    //   return true;
    // }
    // return false;
  };

  setShowCustom = (show: boolean) => {
    this.setState({ showCustom: show });
  };

  setShowModal = (show: boolean) => {
    this.setState({ showModal: show });
  };

  handleChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case '':
        const selectedId = el.value;
        const selectedTemplate = this.props.templatesByOption.filter(
          (x) => x.id == selectedId
        )[0];
        const allTokens = this.getAllTokensInTemplate(selectedTemplate);
        this.setState(
          {
            selectedTemplate,
            allTokens,
            selectedOccupantId: null,
            selectedVehicleId: null,
          },
          () => {
            this.setState({
              valid: this.validateNotification(),
            });
          }
        );
        this.setShowCustom(
          selectedTemplate && selectedTemplate.name === 'Custom'
        );
        break;
      case 'notificationVehicle':
        this.setState(
          {
            selectedVehicleId: el.value,
          },
          () => {
            this.setState({
              valid: this.validateNotification(),
            });
          }
        );
        break;
      case 'notificationOccupant':
        this.setState(
          {
            selectedOccupantId: el.value,
          },
          () => {
            this.setState({
              valid: this.validateNotification(),
            });
          }
        );
        break;
    }
  };

  handleCreateNotification = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    const { value } = el;
    const { webServiceURL } = this.props;
    const { selectedTemplate } = this.state;
    var request: INotificationFromTemplateSaveRequest = {
      templateId: Number(selectedTemplate.id),
      reportId: this.props.reportId,
      vehicleId: this.state.selectedVehicleId,
      occupantId: this.state.selectedOccupantId,
    };
    this.props
      .saveNotificationByTemplate(
        `${webServiceURL}${urls.SAVE_NOTIFICATION_BY_TEMPLATE}`,
        request
      )
      .then((x) => {
        toast.success('Letter Queued');
      });
  };

  handleClose = () => {
    this.setShowModal(false);
  };

  render() {
    const { templatesByOption } = this.props;
    const { showCustom } = this.state;

    return (
      templatesByOption &&
      templatesByOption.length > 0 && (
        <React.Fragment>
          <Row>
            <Col xs='7'>
              {this.props.showLabel && <label>Notification Options</label>}
              <RBSelectList
                title='Letter Options'
                placeholder='Create a letter'
                className='w-100'
                datafield=''
                data={...templatesByOption.map((template) => ({
                  value: template.id,
                  name: template.name,
                }))}
                value={
                  this.state.selectedTemplate != null
                    ? this.state.selectedTemplate.id.toString()
                    : ''
                }
                onChange={this.handleChange}
              />
            </Col>
            <Col xs='5'>
              {showCustom && (
                <AdhocNotificationButton
                  reportId={this.props.reportId}
                  className='w-100'
                //vehicleId={this.props.vehicleId}
                //occupantId={this.props.occupantId}
                />
              )}
              {!showCustom && (
                <Button
                  className='w-100'
                  disabled={!this.state.valid}
                  onClick={(e) => this.handleCreateNotification(e)}
                  variant='secondary'
                >
                  Queue Letter
                </Button>
              )}
            </Col>
          </Row>
          {this.state.selectedTemplate &&
            (this.selectedTemplateRequiresVehicle() ||
              this.selectedTemplateRequiresOccupant()) &&
            this.props.notificationReportInfo.vehicles && (
              <Row>
                <Col>
                  <RBSelectList
                    title='Vehicle'
                    className='margtop-5'
                    placeholder='Select Vehicle'
                    datafield='notificationVehicle'
                    data={this.props.notificationReportInfo.vehicles.map(
                      (v) => ({
                        value: v.id,
                        name: v.name,
                      })
                    )}
                    value={
                      this.state.selectedVehicleId != null
                        ? this.state.selectedVehicleId.toString()
                        : ''
                    }
                    onChange={this.handleChange}
                  />
                </Col>
              </Row>
            )}
          {this.state.selectedVehicleId &&
            this.state.selectedVehicleId != -1 &&
            this.selectedTemplateRequiresOccupant() &&
            this.props.notificationReportInfo.vehicles && (
              <Row>
                <Col>
                  <RBSelectList
                    title='Occupant'
                    className='margtop-5'
                    placeholder='Select Driver / Occupant'
                    datafield='notificationOccupant'
                    data={this.props.notificationReportInfo.vehicles
                      .filter((x) => x.id == this.state.selectedVehicleId)[0]
                      .occupants.map((o) => ({
                        value: o.id,
                        name: o.name,
                      }))}
                    value={
                      this.state.selectedOccupantId != null
                        ? this.state.selectedOccupantId.toString()
                        : ''
                    }
                    onChange={this.handleChange}
                  />
                </Col>
              </Row>
            )}
        </React.Fragment>
      )
    );
  }
}

function mapStateToProps(reduxState) {
  return {
    webServiceURL: reduxState.Application.backendURL,
    cachedAdhocNotification: reduxState.Notifications.adhocNotification,
    notificationTemplates:
      reduxState.NotificationTemplates.notificationTemplates,
    templatesByOption: reduxState.NotificationTemplates.templatesByOption,
    notificationReportInfo:
      reduxState.NotificationTemplates.notificationReportInfo,
    tokenTypes: reduxState.NotificationTemplates.tokenTypes,
  };
}

const mapDispatchToProps = {
  getTemplatesByOption,
  saveNotificationByTemplate,
  getNotificationReportInfo,
  getAllTemplates,
  getAllTokens,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationTemplateSelector);
